import React from 'react';
import image1 from '../../asset/img/pexels-akwice-3094799.jpg'

const About = () => {
    return (

        <div className="hero h-[650px] bg-base-200 mt-8">
            <div className="hero-content flex-col lg:flex-row-reverse">
                <img className=' h-[400px] w-[450px]' alt='' src={image1} />
                <div>
                    <h1 className="text-4xl font-bold">ABOUT ME</h1>
                    <p className="py-6">I am a Front-End Web Developer and also Proficient in Web Design. I love to develop unique web
                        projects. I’m curious, driven, and always looking to improve my abilities. <br></br>

                        Being able to write codes and see the polished results of my labor brings me endless joy. <br></br>

                        💥Skills :
                        Languages : HTML, CSS, Javascript
                        Framworks : Reactjs, Tailwind, Bootstrap
                        Database : Mongodb
                        Authentication : Firebase
                        Other : Github, Material ui</p>

                </div>
            </div>
        </div>
    );
};

export default About;